import Container from './Container'
export default Container


// WEBPACK FOOTER //
// ./src/pages/Authorizing/index.js